module.exports = __webpack_public_path__ + "img/header-theme-dark.1606ed02.svg";